import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { Progress } from "./ui/progress";
import { Button } from "./ui/button";
import { Factory, User, AlertTriangle } from "lucide-react";

const LEVEL_STYLE = {
  1: "bg-rose-100 text-rose-800 border-rose-300",
  2: "bg-amber-100 text-amber-800 border-amber-300",
  3: "bg-emerald-100 text-emerald-800 border-emerald-300",
  4: "bg-sky-100 text-sky-800 border-sky-300",
};

export default function SiteCard({ site, audit }) {
  const navigate = useNavigate();
  const progression = audit ? Number(audit.progression || 0) : 0;
  const started = audit && audit.statut !== "NON_DEMARRE";

  return (
    <Card data-testid="site-card-item" className="overflow-hidden hover:shadow-md transition-shadow">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <Factory className="h-5 w-5 text-emerald-600 shrink-0" />
            <div className="min-w-0">
              <div className="font-heading font-bold text-base truncate" data-testid="site-card-name">{site.nom_site}</div>
              <Badge variant="outline" className="text-[10px] mt-0.5">{site.categorie}</Badge>
            </div>
          </div>
          {audit?.statut && (
            <Badge className={`text-[10px] ${LEVEL_STYLE[3]}`} variant="outline">{audit.statut.replace(/_/g, " ")}</Badge>
          )}
        </div>

        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <User className="h-3.5 w-3.5" />
          {audit?.auditeur_principal || "Non assigné"}
        </div>

        <div>
          <div className="flex justify-between text-xs mb-1">
            <span>Progression</span>
            <span className="font-mono">{progression}%</span>
          </div>
          <Progress value={progression} data-testid="site-card-progress" />
        </div>

        {audit && (
          <div className="grid grid-cols-3 gap-1 text-[11px] text-center">
            <div className="rounded bg-muted p-1.5">
              <div className="font-bold">{audit.nb_questions_evaluees || 0}/{audit.nb_questions_total || 62}</div>
              <div className="text-muted-foreground">Évaluées</div>
            </div>
            <div className="rounded bg-amber-50 p-1.5 dark:bg-amber-950/30">
              <div className="font-bold">{audit.nb_a_revoir || 0}</div>
              <div className="text-muted-foreground">À revoir</div>
            </div>
            <div className="rounded bg-rose-50 p-1.5 dark:bg-rose-950/30">
              <div className="font-bold flex items-center justify-center gap-0.5">
                <AlertTriangle className="h-3 w-3" />{audit.nb_non_conformes || 0}
              </div>
              <div className="text-muted-foreground">NC</div>
            </div>
          </div>
        )}

        <Button
          className="w-full bg-emerald-600 hover:bg-emerald-700"
          data-testid="site-card-start-audit-button"
          disabled={!audit}
          onClick={() => audit && navigate(`/audits/${audit.audit_id}`)}
        >
          {started ? "Continuer l'audit" : "Commencer l'audit"}
        </Button>
      </CardContent>
    </Card>
  );
}
